import { normalizeIncomingLog } from './logParser';

const services = [
  'runtime',
  'telemetry',
  'console-ui',
  'editor-api',
  'templates-api',
  'workflow-engine',
  'auth-gateway'
];

const bodies = [
  'Span exported to OTLP collector',
  'HTTP latency crossed warning threshold',
  'Memory pressure normalized after GC',
  'Token validation failed for incoming request',
  'Job enqueue acknowledged by queue service',
  'Datasource sync checkpoint persisted',
  'Unhandled rejection detected in worker loop'
];

const severityPool = [9, 13, 17] as const;

const randomItem = <T,>(items: readonly T[]): T => items[Math.floor(Math.random() * items.length)];

const randomHex = (size: number): string =>
  Array.from({ length: size }, () => Math.floor(Math.random() * 16).toString(16)).join('');

export const createFakeLog = () => {
  const severityNumber = randomItem(severityPool);

  return normalizeIncomingLog({
    timestamp: Date.now(),
    severityNumber,
    body: randomItem(bodies),
    attributes: {
      service: {
        name: randomItem(services)
      },
      'deployment.region': randomItem(['iad', 'gru', 'scl'])
    },
    traceId: randomHex(32),
    spanId: randomHex(16)
  });
};
